'use client';

import {
  BottomSheetHandleArea,
  BottomSheetTitle,
  BottomSheetTitleBox,
  BottomSheetTitleContainer,
  Dim,
  IcDelete,
  IconButton,
  Sheet,
  SheetContent,
  SheetDimMotion,
  SheetMotion,
  SheetPortal,
  SheetTrigger,
  Typography,
} from '@musinsa/mds';
import type React from 'react';
import { useState } from 'react';
import { usePreventBodyScroll } from '../../common/hooks/usePreventBodyScroll';

interface ProductCuratorLinkInfoBottomSheetProps {
  children: React.ReactNode;
}

export const ProductCuratorLinkInfoBottomSheet = ({
  children,
}: ProductCuratorLinkInfoBottomSheetProps) => {
  const [isOpen, setIsOpen] = useState(false);

  // 바텀시트 열렸을 때 뒤쪽 스크롤 방지
  usePreventBodyScroll({ open: isOpen });

  return (
    <Sheet direction="bottom" defaultOpen={false} open={isOpen}>
      <SheetTrigger asChild onClick={() => setIsOpen(true)}>
        {children}
      </SheetTrigger>
      <SheetPortal>
        <SheetContent onPointerDownOutside={() => setIsOpen(false)}>
          <SheetMotion direction="bottom">
            <BottomSheetTitle>
              <BottomSheetHandleArea />
              <BottomSheetTitleContainer>
                <BottomSheetTitleBox className="py-3">
                  <Typography size="18" weight="medium">
                    상품 제휴 링크 실적 안내
                  </Typography>
                </BottomSheetTitleBox>
                <IconButton size="size28x28" onClick={() => setIsOpen(false)}>
                  <IcDelete />
                </IconButton>
              </BottomSheetTitleContainer>
            </BottomSheetTitle>
            <ProductCuratorLinkInfoBottomSheetContent />
          </SheetMotion>
        </SheetContent>
        <SheetDimMotion>
          <Dim />
        </SheetDimMotion>
      </SheetPortal>
    </Sheet>
  );
};

const ProductCuratorLinkInfoBottomSheetContent = () => (
  <div className="flex flex-col px-4 bg-white safe-area-bottom">
    <div className="flex flex-col pb-[12px]!">
      <ul>
        <li className="flex gap-[4px] py-1">
          <Typography colorScheme="gray-600" variant="body13pxReg">
            •
          </Typography>
          <Typography colorScheme="gray-600" variant="body13pxReg">
            {`'상품 개별 제휴 링크'를 통해 발생한 거래 건을 기준으로 한 실적입니다.`}
          </Typography>
        </li>
        <li className="flex gap-[4px] py-1">
          <Typography colorScheme="gray-600" variant="body13pxReg">
            •
          </Typography>
          <Typography colorScheme="gray-600" variant="body13pxReg">
            방문 : 상품 제휴 링크에 방문한 '총 방문 건 수'입니다.
          </Typography>
        </li>
        <li className="flex gap-[4px] py-1">
          <Typography colorScheme="gray-600" variant="body13pxReg">
            •
          </Typography>
          <Typography colorScheme="gray-600" variant="body13pxReg">
            {`결제 건 : 상품 제휴 링크에서 상품을 주문하고 결제 완료한 '총 결제 건 수'입니다.`}
          </Typography>
        </li>
        <li className="flex gap-[4px] py-1">
          <Typography colorScheme="gray-600" variant="body13pxReg">
            •
          </Typography>
          <Typography colorScheme="gray-600" variant="body13pxReg">
            {`결제 금액 : 상품 제휴 링크에서 상품을 주문하고 결제 완료한 '총 결제 금액'입니다. (배송비 제외)`}
          </Typography>
        </li>
        <li className="flex gap-[4px] py-1">
          <Typography colorScheme="gray-600" variant="body13pxReg">
            •
          </Typography>
          <Typography colorScheme="gray-600" variant="body13pxReg">
            예상 수익 : 예상 수익은 결제 건을 토대로 한 큐레이터님의 예상 수익입니다. (확정 수익
            집계 구간과 상이하여 금액이 상이할 수 있습니다.)
          </Typography>
        </li>
        <li className="flex gap-[4px] py-1">
          <Typography colorScheme="gray-600" variant="body13pxReg">
            •
          </Typography>
          <Typography colorScheme="gray-600" variant="body13pxReg">
            확정 수익 : 활동월(N월)을 기준으로 익월 20일까지 구매 확정(취소/환불 반영)된 거래 건을
            토대로 한 확정 수익입니다.
          </Typography>
        </li>
      </ul>
    </div>
  </div>
);
